/**
 * This function helps catch currencies with different float rules.
 * Generally we display 2 ints past the decimal (i.e $1.25).
 * @param currencyCode - The new currency currencyCode
 * @returns currencyPrecision
 */
export function getCurrencyPrecision(currencyCode) {
  const noFloat = {
    BIF: true,
    BYR: true,
    CLP: true,
    DJF: true,
    GNF: true,
    HUF: true,
    ISK: true,
    JPY: true,
    KMF: true,
    KRW: true,
    KWR: true,
    PYG: true,
    RWF: true,
    TWD: true,
    UGX: true,
    UYI: true,
    VND: true,
    VUV: true,
    XAF: true,
    XOF: true,
    XPF: true,
  }

  return noFloat[currencyCode] ? 0 : 2
}
